export { default as PaymentSchedule } from "./paymentSchedule";
